import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=195587b9&scoped=true"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=195587b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195587b9",
  null
  
)

export default component.exports